import React, { useState, useEffect, useRef } from 'react';
import { Link, useParams } from 'react-router-dom';
import '../../pagescss/OnlinePracticsQuestions.css';
import AllQuestions from '../AllData/AllQuestions';
import Loading from '../home/Loading';
import 'katex/dist/katex.min.css';
import Latex from 'react-latex';
import TopNavbar from '../home/TopNavbar';
import QuestionImage from './QuestionImage';






const PracticsRandomQuestions = () => {
    const { subject } = useParams();
    const [loading, setLoading] = useState(true);
    const [questionList, setQuestionList] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [showAnswer, setShowAnswer] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);
    const [bookmarkedQuestions, setBookmarkedQuestions] = useState([]);
    const [savedQuestions, setSavedQuestions] = useState([]);


    // Timer states
    const [timeElapsed, setTimeElapsed] = useState(0);
    const timerRef = useRef(null);


    const [randomQuestions, setQuestions] = useState([]);
    const shuffleQuestions = (array) => {
        const shuffled = [...array];
        for (let i = shuffled.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
        }
        return shuffled;
    };
    useEffect(() => {
        const shuffledQuestions = shuffleQuestions(AllQuestions);
        setQuestions(shuffledQuestions);
    }, []);



    useEffect(() => {
        // Check if randomQuestions is a function or data
        const randomQuestionsData = typeof randomQuestions === 'function' ? randomQuestions() : randomQuestions;

        if (subject === "all") {
            setQuestionList(randomQuestionsData || []);
        } else {
            const filteredQuestions = randomQuestions.filter(question =>
                question.subject === subject
            );
            setQuestionList(filteredQuestions || []);
        }
        setLoading(false);
    }, [randomQuestions, subject]);



    // Load bookmarks from localStorage
    useEffect(() => {
        const storedBookmarks = localStorage.getItem('questionBookmarks');
        if (storedBookmarks) {
            setBookmarkedQuestions(JSON.parse(storedBookmarks));
        }
        setLoading(false);
    }, []);


    // Timer effect
    useEffect(() => {
        // Start timer when a new question is shown and no answer has been selected
        if (!showAnswer && questionList.length > 0) {
            startTimer();
        } else {
            stopTimer();
        }
        // Cleanup timer on component unmount or question change
        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
            }
        };
    }, [currentIndex, showAnswer, questionList.length]);

    const startTimer = () => {
        setTimeElapsed(0);
        if (timerRef.current) {
            clearInterval(timerRef.current);
        }

        timerRef.current = setInterval(() => {
            setTimeElapsed(prevTime => prevTime + 1);
        }, 1000);
    };

    const stopTimer = () => {
        if (timerRef.current) {
            clearInterval(timerRef.current);
            timerRef.current = null;
        }
    };

    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    };

    // Helper function to compare question IDs (handles both string and object formats)
    const compareQuestionIds = (id1, id2) => {
        // Extract the actual ID string from both IDs
        const extractId = (id) => {
            if (typeof id === 'object' && id.$oid) {
                return id.$oid; // MongoDB ObjectId format
            }
            return id; // String format
        };

        return extractId(id1) === extractId(id2);
    };

    // Handle bookmark toggle with localStorage
    const handleBookmark = () => {
        //  if (!userId) {
        //      setShowLoginMessage(true);
        //      return;
        //  }

        const currentQuestion = questionList[currentIndex];
        const isBookmarked = bookmarkedQuestions.some(
            bq => compareQuestionIds(bq.questionId, currentQuestion._id) 
        );

        let updatedBookmarks;

        if (isBookmarked) {
            // Remove bookmark
            updatedBookmarks = bookmarkedQuestions.filter(
                bq => !(compareQuestionIds(bq.questionId, currentQuestion._id) )
            );
        } else {
            // Add bookmark
            const newBookmark = {
                questionId: currentQuestion._id, // Store the ID as-is (could be object or string)
                timestamp: new Date().toISOString()
            };
            updatedBookmarks = [...bookmarkedQuestions, newBookmark];
        }

        // Update localStorage and state
        localStorage.setItem('questionBookmarks', JSON.stringify(updatedBookmarks));
        setBookmarkedQuestions(updatedBookmarks);
    };

    const isQuestionBookmarked = () => {
        const currentQuestion = questionList[currentIndex];
        return bookmarkedQuestions.some(
            bq => compareQuestionIds(bq.questionId, currentQuestion._id) 
        );
    };







    const storeQuestions = (questionsId) => {
        const storedQuestionsIdInLocalStorage = JSON.parse(localStorage.getItem('saveQuestionsIdInLocalStorage')) || [];

        if (!storedQuestionsIdInLocalStorage.includes(questionsId)) {
            const updatedsaveQuestionsInLocalStorage = [...storedQuestionsIdInLocalStorage, questionsId];
            localStorage.setItem('saveQuestionsIdInLocalStorage', JSON.stringify(updatedsaveQuestionsInLocalStorage));
        }
        const storedQuestions = JSON.parse(localStorage.getItem('saveQuestionsIdInLocalStorage')) || [];
        setSavedQuestions(storedQuestions);

    };

    const handleOptionSelect = async (option) => {
        const currentQuestion = questionList[currentIndex];
        setSelectedOption(option);
        setShowAnswer(true);

        // Stop timer only if the answer is correct
        if (currentQuestion && option === currentQuestion.answer) {
            stopTimer();
        }

      

        if (questionList[currentIndex] && questionList[currentIndex]._id.$oid) {
            await storeQuestions(questionList[currentIndex]._id.$oid);
        }
    };

    // Function to render text with LaTeX
    const renderWithLatex = (text) => {
        if (!text) return null;

        // Check if text contains LaTeX patterns
        if (text.includes('$') || text.includes('\\')) {
            return <Latex>{text}</Latex>;
        }
        return text;
    };

    const handleRefresh = () => {
        // Reset to a new random question instead of reloading the page
        setCurrentIndex(prev => (prev + 1) % questionList.length);
        setShowAnswer(false);
        setSelectedOption(null);
    };

  
    if (loading) {
        return <Loading message='Loading......' />;
    }

    if (questionList.length === 0) {
        return <Loading message='Loading......' />;
    }

    const currentQuestion = questionList[currentIndex];
    if (!currentQuestion) {
        return <div className="practice-container">Question not found.</div>;
    }

    const isBookmarked = isQuestionBookmarked();

    return (
        <div className="practice-container">
           

            <TopNavbar name={(currentQuestion.subject) + ": " + (currentQuestion.topicname)} />


            <div className="question-card">
                 <br></br>
                <div className="question-header">
                    <span className="question-topic"> {currentQuestion.subject}: {currentQuestion.topicname}  {currentQuestion.year ? (<>NEET {currentQuestion.year} </>) : (<></>)} </span>


                  
                        <div className="header-controls">
                            <div className="timer">
                                <span className="timer-icon">⏱️ </span>
                                <span className="timer-text">{formatTime(timeElapsed)}</span>
                            </div>

                           
                                <button
                                    onClick={handleBookmark}
                                    className={`bookmark-button ${isBookmarked ? 'bookmarked' : ''}`}
                                    aria-label={isBookmarked ? 'Remove bookmark' : 'Add bookmark'}
                                >
                                    <span className='bookmark-text'>{isBookmarked ? <p className='mark-text'>Bookmarked</p> : <p className='mark-text'>Bookmark</p>}</span>
                                </button>
                           
                        </div>
                  
                </div>

                
                        <div className="question-content">
                            {currentQuestion.question_img ? (
                                 <QuestionImage
                            src={`/questionsPhoto/${currentQuestion.question_img}`}
                            alt="Question"
                        />
                            ) : (
                                <p className="question-text">
                                    {renderWithLatex(currentQuestion.question)}
                                </p>
                            )}
                        </div>

                      

                        <div className="options-container">
                            {['option1', 'option2', 'option3', 'option4'].map((option, index) => (
                                <div
                                    key={option}
                                    className={`option-item 
                                        ${selectedOption === option ? 'selected' : ''}
                                        ${showAnswer && currentQuestion.answer === option ? 'correct' : ''}
                                        ${showAnswer && selectedOption === option && selectedOption !== currentQuestion.answer ? 'incorrect' : ''}
                                    `}
                                    onClick={() => !showAnswer && handleOptionSelect(option)}
                                    role="button"
                                    tabIndex={0}
                                    onKeyPress={(e) => {
                                        if (e.key === 'Enter' && !showAnswer) {
                                            handleOptionSelect(option);
                                        }
                                    }}
                                >
                                    <span className="option-letter">{String.fromCharCode(65 + index)}</span>
                                    <span className="option-text">
                                        {renderWithLatex(currentQuestion[option])}
                                    </span>
                                </div>
                            ))}
                        </div>
               

                <div className="navigation-controls">
                    <button onClick={handleRefresh} className="nav-button next-button" >
                        Solve next question
                    </button>
                </div>

                {showAnswer && currentQuestion.solution && (
                         <>
                             <Link to={`/report-send/${currentQuestion._id.$oid}`} className="report-btn"  >  Send report if we mistake with answer </Link>
                                                     <br></br>
                    <div className="answer-section">
                            
                        <p className="correct-answer">
                            <strong>Correct Answer: </strong>
                            {renderWithLatex(currentQuestion[currentQuestion.answer])}
                        </p>
                        <p className="question-solution">
                             {currentQuestion.solutionimg ? (
                                      <QuestionImage
                                        src={`/solutionsimg/${currentQuestion.solutionimg}.png`}
                                        alt="Solution"
                                        className='question-img-solutin'
                                    />
                                ) : (
                                    <>
                                        <strong>Solution: </strong>
                                        {currentQuestion.solution.split('\n').map((line, index) => (
                                            <span key={index}>
                                                {renderWithLatex(line)}
                                                <br />
                                            </span>
                                        ))}
                                    </>
                                )}
                           
                        </p>
                        <p className="time-taken">
                            <strong>Time Taken: </strong>
                            {formatTime(timeElapsed)}
                        </p>
                    </div> </>
                )}
            </div>
        </div>
    );
};

export default PracticsRandomQuestions;